/**
 * Which platform alert strips this user has closed, remembered per browser.
 *
 * Keyed by user AND workspace: a COMPANY alert is shared by everyone in the workspace, and one
 * person closing it must not hide it from colleagues — nor from themselves in another workspace.
 *
 * The alert key carries `since` (the disconnect time for WhatsApp), so a fresh incident of the
 * same kind is a different key and comes back on its own.
 */
export const dismissalStorageKey = (userId, insuranceProviderId) => (
  userId && insuranceProviderId ? `platformAlertsDismissed.${userId}.${insuranceProviderId}` : null
);

export const alertDismissalKey = (alert) => [
  alert.code,
  alert.scope,
  alert.subject || '',
  alert.since || '',
].join(':');

export const loadDismissed = (storageKey) => {
  if (!storageKey) return [];
  try {
    const parsed = JSON.parse(localStorage.getItem(storageKey));
    return Array.isArray(parsed) ? parsed.filter((key) => typeof key === 'string') : [];
  } catch (e) {
    return [];
  }
};

export const saveDismissed = (storageKey, keys) => {
  if (!storageKey) return;
  try {
    if (keys.length) localStorage.setItem(storageKey, JSON.stringify(keys));
    else localStorage.removeItem(storageKey);
  } catch (e) {
    // Private mode or a full quota: the strip still closes for this session.
  }
};

/**
 * Drops dismissals whose alert is no longer live, so a problem that is fixed and later comes back
 * shows its banner again. The paid-WhatsApp alerts have no `since`, so this is the only thing that
 * resurrects them.
 *
 * Only call it with a list that actually loaded: an empty list before the first fetch returns
 * would otherwise wipe every dismissal on each page load.
 */
export const pruneDismissed = (keys, alerts) => {
  const live = new Set((alerts || []).filter(Boolean).map(alertDismissalKey));
  return keys.filter((key) => live.has(key));
};
